import { render, staticRenderFns } from "./addVipLevel.vue?vue&type=template&id=4a4cf7c0&scoped=true"
import script from "./addVipLevel.vue?vue&type=script&lang=js"
export * from "./addVipLevel.vue?vue&type=script&lang=js"
import style0 from "./addVipLevel.vue?vue&type=style&index=0&id=4a4cf7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4cf7c0",
  null
  
)

export default component.exports